var React = require('react');

function CheckmarkSmall (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.4 16.1l-3-3.1c-.4-.4-.4-1 0-1.4.4-.4 1-.4 1.4 0l2.3 2.4 6.1-6.1c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-6.8 6.8c-.4.4-1 .4-1.4 0z"}));
}

CheckmarkSmall.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = CheckmarkSmall;

CheckmarkSmall.default = CheckmarkSmall;
